/* eslint-disable camelcase */
import { GTAG_ID } from 'settings';

// ATENÇÃO!!!! não alterar os valores abaixo (pois quebra no pixel do G4), somente add
export enum enFeatures {
  CHECKOUT_ELEMENTS = 'checkout-elements',
  EXITPOPUP = 'exit-pop-up',
  TEMA = 'tema',
  CHAT = 'chat',
  TOAST = 'toast',
  OBRIGADO_UPSELL = 'obrigado-upsell',
  CONFIRMACAO_EMAIL = 'confirmacao-email',
  PARCELAMENTO_18X = 'parcelamento-18x',
  BACK_REDIRECT = 'back-redirect'
}

export class AnalyticsG4 {
  private dataUser: { user_id: number; belt: string };

  public config(user_id: number, belt: string) {
    if (!belt) {
      belt = 'White Belt';
    }

    this.dataUser = { belt, user_id };

    window.gtag('js', new Date());

    window.gtag('config', GTAG_ID, {
      send_page_view: false,
      user_id,
      user_properties: {
        belt
      },
      custom_map: { belt }
    });

    this.sendEvent('page_view');
  }

  public sendSuccess(feature?: enFeatures) {
    this.sendEvent('success', feature);
  }

  public sendError(feature?: enFeatures) {
    this.sendEvent('error', feature);
  }

  public sendPageView(data: { title?: string; feature?: enFeatures }) {
    const properties = {
      ...(!!data?.title ? { title: data?.title } : {})
    };

    this.sendEvent('page_view', data?.feature, {
      ...properties
    });
  }

  private sendEvent(event: 'page_view' | 'success' | 'error', feature?: enFeatures, properties?: object) {
    let feat: any = {};
    if (!!feature) {
      feat = event === 'page_view' ? { content_group: feature } : { feature };
    }

    window.gtag('event', event, {
      ...feat,
      ...properties,
      ...this.dataUser
    });
  }
}

export const analyticsG4 = new AnalyticsG4();
